<div class="breadcrumb-container d-flex fd-row jc-start ai-center">
  <div *ngFor="let link of links; let i = index; let last = last" class="d-flex jc-center ai-center">
    <ng-container *ngIf="!last; else lastLabel">
      <a matRipple class="breadcrumb-button" [routerLink]="link.route">
        <span>
          {{ link.displayName }}
        </span>
      </a>
      <mat-icon *ngIf="!last">chevron_right</mat-icon>
    </ng-container>

    <ng-template #lastLabel>
      <span class="breadcrumb-button">{{ link.displayName }}</span>
    </ng-template>
  </div>
</div>
